export default {
  path: '/remotePatrol',
  meta: {
    auth: true,
    title: '远程巡视',
  },
  // redirect: 'cos/index',
  component: () => import('_views/remotePatrol/index.vue'),
  children: [
    {
      path: 'devicePatrol',
      meta: {
        auth: true,
        title: '设备巡视',
      },
      component: () => import('_views/remotePatrol/devicePatrol/index.vue'),
      children: [
        {
          // path: ':id',
          path: 'detail',
          name: 'DevicePatrolDetail',
          component: () =>
            import('_views/remotePatrol/devicePatrol/detail/index.vue'),
          props: true,
        },
      ],
    },
    {
      path: 'patrolRecord',
      meta: {
        auth: true,
        title: '巡视记录',
      },
      component: () => import('_views/remotePatrol/patrolRecord/index.vue'),
    },
  ],
}
